/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';
import { Store, select } from '@ngrx/store';
import { UserState } from 'src/app/state/user-state';
import { environment } from 'src/environments/environment';
import * as signalR from '@microsoft/signalr';
import { selectClientId } from 'src/app/state/reducer/user.reducer';
import { NotificaitonResponse } from '../models/responses/notificaitonResponse';
import * as UserActions from 'src/app/state/actions/user.actions';
import { Router } from '@angular/router';
import { ROUTES } from '../constants/routes';
import { CONNECTION_EVENTS } from '../constants/enums';

export interface IHubConnection {
  connection: signalR.HubConnection | null;
  url: string;
  updateMBC: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  clientId: string | undefined;
  hubConnections: IHubConnection[] = [];
  private isDisconnecting = false;

  constructor(
    private store: Store<UserState>,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.hubConnections = [
      { connection: null, url: environment.loyaltyHubUrl, updateMBC: true },
      { connection: null, url: environment.spendingHubUrl, updateMBC: true },
      {
        connection: null,
        url: environment.cateringPurchaseHubUrl,
        updateMBC: true,
      },
      {
        connection: null,
        url: environment.bettingPurchaseHubUrl,
        updateMBC: false,
      },
      {
        connection: null,
        url: environment.bettingSpendingHubUrl,
        updateMBC: true,
      },
    ];
  }

  connectToSignalR() {
    this.store.pipe(select(selectClientId)).subscribe((client_ID: string) => {
      this.clientId = client_ID;
      if (this.clientId === null) {
        return;
      }
      this.hubConnections.forEach((hubConnection: any) => {
        this.establishHubConnection(this.clientId!, hubConnection);
      });
    });
  }

  establishHubConnection(clientId: string, hubConnection: any) {
    hubConnection.connection = SignalRConnection.getLoyaltyConnectionInstance(
      clientId!,
      hubConnection.connection!,
      hubConnection.url
    );
    hubConnection.connection.onclose(() => {
      if (hubConnection.connection?.state === CONNECTION_EVENTS.CONNECTED) {
        this.disconnectFromSignalR();
      }
    });
    if (
      hubConnection.connection &&
      hubConnection.connection.state === CONNECTION_EVENTS.DISCONNECTED
    ) {
      hubConnection
        .connection!.start()
        .then()
        .catch(function (err: Error) {
          return console.error(err.toString());
        });

      hubConnection.connection!.on(
        CONNECTION_EVENTS.RECIEVE_MESSAGE,
        (message: string) => {
          const notification: NotificaitonResponse = JSON.parse(message);
          if (notification.NotificationType == '1') {
            this.dialogService.openError(
              notification.MessageTitle,
              notification.MessageDescription
            );
          } else {
            if (hubConnection.updateMBC && notification.MBC) {
              const newPointsCount = Number(notification.MBC);
              this.store.dispatch(
                UserActions.UPDATE_POINTS_COUNT({ pointsCount: newPointsCount })
              );
            }
            if (
              notification.MessageDescription.includes(
                'Uspešno kupljen MaxLoyalty vaučer'
              )
            ) {
              this.dialogService.openVoucherDialog(
                notification.MessageTitle,
                notification.MessageDescription,
                true
              );
            } else {
              this.dialogService.openConfirmation(
                notification.MessageTitle,
                notification.MessageDescription,
                hubConnection.updateMBC
              );
            }
          }
        }
      );
      hubConnection.connection!.on(CONNECTION_EVENTS.DISCONNECT, () => {
        if (hubConnection.connection?.state === CONNECTION_EVENTS.CONNECTED) {
          this.disconnectFromSignalR();
        }
      });
    }
  }

  async disconnectFromSignalR(): Promise<void> {
    if (this.isDisconnecting) {
      return;
    }
    this.isDisconnecting = true;

    const anyDisconnected = this.hubConnections.some(
      (hubConnection) =>
        !hubConnection.connection ||
        hubConnection.connection.state === CONNECTION_EVENTS.DISCONNECTED
    );
    if (anyDisconnected) {
      this.isDisconnecting = false;
      return;
    }
    sessionStorage.clear();
    localStorage.clear();

    const disconnectPromises = this.hubConnections.map(
      async (hubConnection) => {
        if (hubConnection.connection?.state === CONNECTION_EVENTS.CONNECTED) {
          await hubConnection.connection.stop(); // Ensure it fully stops
        }
        hubConnection.connection = null; // Explicitly set connection to null
      }
    );

    await Promise.all(disconnectPromises); // Ensure all connections are stopped before proceeding

    this.dialogService.closeDialog();
    this.router.navigate([ROUTES.LOGIN]);
    this.isDisconnecting = false; // Reset flag after successful disconnection
  }
}

class SignalRConnection {
  private constructor() {
    // Private constructor to prevent instantiation.
  }

  public static getLoyaltyConnectionInstance(
    clientId: string,
    connection: signalR.HubConnection,
    url: string
  ): signalR.HubConnection {
    if (!connection) {
      connection = new signalR.HubConnectionBuilder()
        .withUrl(url + clientId, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.None)
        .withAutomaticReconnect([0, 2000, 5000, 10000])
        .build();
    }
    return connection;
  }
}
